import { useAtom } from 'jotai';
import { CircularProgress, Box } from '@mui/material';

import { style } from 'typestyle';

import { appLoadingAtom } from '../../store/atoms';
import { ADALONG_COLORS } from '../../styles';
import logo from '../../assets/img/site/logo_alone_white.png';

function AppLoading() {
  const [loadingState] = useAtom(appLoadingAtom);

  if (!loadingState) {
    return null;
  }

  return (
    <Box className={loading}>
      <Box className={logoContainer}>
        <img src={logo} className={logoImg} alt="Loading..." />
      </Box>
      <Box className={progress}>
        <CircularProgress sx={{ color: ADALONG_COLORS.FLASH_BLUE }} />
      </Box>
    </Box>
  );
}

export default AppLoading;

const loading = style({
  position: 'fixed',
  zIndex: 10,
  width: '100%',
  height: '100%',
  backgroundColor: ADALONG_COLORS.SMOOTH_BLACK,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const logoContainer = style({
  marginBottom: 30,
});

const logoImg = style({
  height: 80,
  opacity: 1,
});

const progress = style({ textAlign: 'center' });